import { tns } from 'tiny-slider'


document.addEventListener('DOMContentLoaded', _=> {
    document.querySelectorAll('.tabs-carousel').forEach(tabsWrapper => {
        const tabsNavCarousel = tabsWrapper.querySelector('.tabs-carousel-nav-carousel')
        const tabsContentCarousel = tabsWrapper.querySelector('.tabs-carousel-content-carousel')
        const tabsNavCarouselLinks = tabsNavCarousel.querySelectorAll('.tabs-carousel-nav-link')
        const tabsNavNext = tabsWrapper.querySelector('.tabs-carousel-nav-next')
        const tabsNavPrev = tabsWrapper.querySelector('.tabs-carousel-nav-prev')
        const tabsContentNext = tabsWrapper.querySelector('.tabs-carousel-content-next')
        const tabsContentPrev = tabsWrapper.querySelector('.tabs-carousel-content-prev')
        const tabsContentBackbtn = tabsWrapper.querySelectorAll('.tabs-carousel-content-back-btn')

        function transitionTransBg(elm) {
            elm.closest('.bg-transition').classList.toggle('transitioned')
        }


        const navSlider = tns({
            container: tabsNavCarousel,
            items: 1,
            slideBy: 1,
            gutter: 20,
            nav: false,
            prevButton: tabsNavPrev,
            nextButton: tabsNavNext,
            arrowKeys: false,
            lazyload: true,
            loop: false,
            responsive: {
                768: {
                    items: 2,
                    gutter: 35,
                },
                1200: {
                    items: 4,
                    gutter: 50,
                },
            },
        })

        const contentSlider = tns({
            container: tabsContentCarousel,
            prevButton: tabsContentPrev,
            nextButton: tabsContentNext,
            items: 1,
            slideBy: 1,
            gutter: 20,
            nav: false,
            arrowKeys: false,
            lazyload: true,
            loop: false,
            mode: "gallery",
            startIndex: 0,
        })

        tabsNavCarouselLinks.forEach(link => {
            link.addEventListener('click', _=> {
                contentSlider.goTo(link.getAttribute('data-content-carousel-target'))
                transitionTransBg(link)
            })
        })

        tabsContentBackbtn.forEach(btn => {
            btn.addEventListener('click', _=> {
                transitionTransBg(btn)
            })
        })
    })
})